export function noop(..._args: any) {}



// WEBPACK FOOTER //
// ../src/utilities/other/noop.ts